import React, { FC } from 'react';
import { SkippableFragment } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

import { useDuration } from '@/scenarios/legacy-player/hooks/useDuration';

import { isLastCredit } from '../../../utils/is-last-credit';

import { CompoundCreditSkipButtonGroup } from './component';

interface FilterProps {
    className?: string;
    currentFragment: SkippableFragment | undefined;
}

export const CompoundCreditSkipButtonGroupContainer: FC<FilterProps> = ({
    currentFragment,
    ...rest
}) => {
    const duration = useDuration();

    if (currentFragment?.type === 'CREDITS' && !isLastCredit(currentFragment.endTime, duration)) {
        return <CompoundCreditSkipButtonGroup currentFragment={currentFragment} {...rest} />;
    }

    return null;
};
